import { lex, MdToken } from '../parser'

const stripInline = (tokens: MdToken[]): string => {
  if (!tokens || !tokens.length) return ''
  return tokens.map((t) => {
    switch (t.type) {
      case 'text':
        return t.tokens ? stripInline(t.tokens) : (t.text || '')
      case 'strong':
      case 'em':
      case 'del':
        return t.tokens ? stripInline(t.tokens) : (t.text || '')
      case 'link':
        return t.tokens ? stripInline(t.tokens) : (t.text || '')
      case 'codespan':
        return t.text || ''
      case 'br':
        return '\n'
      case 'escape':
        return t.text || ''
      case 'html':
        return ''
      case 'image':
        return t.text || ''
      default:
        return t.text || ''
    }
  }).join('')
}

const stripBlock = (tokens: MdToken[]): string => {
  if (!tokens || !tokens.length) return ''
  const out: string[] = []
  for (const t of tokens) {
    switch (t.type) {
      case 'heading':
        out.push(stripInline(t.tokens || []))
        break
      case 'paragraph':
        out.push(stripInline(t.tokens || []))
        break
      case 'blockquote':
        out.push(stripBlock(t.tokens || []))
        break
      case 'list': {
        const isTask = !!t.items && t.items.some((i: any) => i.task)
        const isOrdered = !!t.ordered
        const lines: string[] = []
        ;(t.items || []).forEach((item: any, i: number) => {
          let bullet = '• '
          if (isTask && item.task) bullet = item.checked ? '☑ ' : '☐ '
          else if (isOrdered) bullet = `${i + 1}. `
          const inner = stripBlock(item.tokens || [])
          lines.push(bullet + inner)
        })
        out.push(lines.join('\n'))
        break
      }
      case 'code':
        out.push(t.text || '')
        break
      case 'space':
        out.push('')
        break
      case 'hr':
        out.push('')
        break
      case 'table': {
        const rows: string[] = []
        if (t.header) {
          rows.push(t.header.map((c: any) => stripInline(c.tokens || [])).join('\t'))
        }
        if (t.rows) {
          for (const row of t.rows) {
            rows.push(row.map((c: any) => stripInline(c.tokens || [])).join('\t'))
          }
        }
        out.push(rows.join('\n'))
        break
      }
      case 'html':
        break
      default:
        if (t.tokens) out.push(stripInline(t.tokens))
        else if (t.text) out.push(t.text)
    }
  }
  return out.filter((s) => s.length > 0).join('\n\n')
}

export const stripMarkdown = (src: string): string => {
  if (!src) return ''
  try {
    const tokens = lex(src)
    return stripBlock(tokens)
  } catch {
    return src
  }
}
